import React from 'react';

function ArrowIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='5' height='8' viewBox='0 0 5 8' fill='none'>
      <path
        d='M1.71 7.28997L4.3 4.69997C4.69 4.30997 4.69 3.67997 4.3 3.28997L1.71 0.699971C1.08 0.0799712 0 0.519971 0 1.40997V6.57997C0 7.47997 1.08 7.91997 1.71 7.28997Z'
        fill='white'
      />
    </svg>
  );
}

export default ArrowIcon;
